"use strict";

const compareCookieExpireDays = 7;
var pingRequest = null;
var timer = null;

module.exports = {

    items: [],
    locale: "bg",
    version: 1,
    listeners: {},

    empty: function() {
        return !this.items.length;
    },

    count: function() {
        return this.items.length;
    },

    add: function(item) {
        for (var i = 0, len = this.items.length; i < len; i++) {
            // if (this.items[i].category_id != item.category_id) {
            //     throw "DIFFERENT_CATEGORY";
            // }

            if (this.items[i].id == item.id && !item.isIndex) {
                throw "PRODUCT_ALLREADY_EXISTS";
            }
        }

        if (this.items.length >= 3) {
            throw "LIMIT_EXCEEDED";
        }

        this.items.push(item);

        this.fire("add", [ item ]);
        this.save();
    },

    clear: function(save = false) {
        var items = this.items.slice(0);

        this.items.splice(0, this.items.length);

        if (save) {
            this.save();
        }

        this.fire("clear", [ items ]);
    },

    remove: function(index, isIndex = false) {

        var item = this.items[index];
        
        this.items.splice(index, 1);
        item.isIndex = isIndex;
        this.fire("remove", [ item ]);
        this.save();
    },

    // Saves compare state
    save: function() {
        var obj = {
            version: this.version,
            items: this.items
        };

        window.Utils.setCookie(this.getLocalStorageKey(), this.serialize(), compareCookieExpireDays);
        localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(obj));

        var updateValue = new Date().getTime() + Math.random();
        localStorage.setItem("UPDATE_COMPARE", "" + updateValue);

        this.ping();
    },

    ping: function() {
        if (pingRequest) {
            pingRequest.abort();
        }

        var pingUrl = document.body.dataset["pingUrl"];

        pingRequest = $.ajax({
            cache: false,
            type: "GET",
            url: pingUrl,
            success: function(data) {
                // Do nothing
            }
        });
    },

    serialize: function() {

        var items = [];

        for (var i = 0, len = this.items.length; i < len; i++) {

            var item = this.items[i];

            items.push({
                id: item.id
            });

        }

        return JSON.stringify(items);

    },

    getLocalStorageKey: function() {
        return "compare_" + this.locale;
    },


    loadFromStorage: function() {

        if (window.Utils.getCookie(this.getLocalStorageKey())) 
        {
            var compareJSON = localStorage.getItem(this.getLocalStorageKey());
            var compareJSON = JSON.parse(compareJSON ? compareJSON : "{}");

            if (this.version == compareJSON.version) 
            {
                this.items = compareJSON["items"];
            }
            else {
                this.items = [];
            }

            this.fire("change");
        }
    },

    setItems: function(items) {
        this.items = items;
        this.fire("change");
    },

    init: function() {
        this.locale = document.body.dataset["locale"];

        // Fire change on add remove and clear events
        this.on([ "add", "remove", "clear" ], function() {
            this.fire("change");
        }.bind(this));

        if (document.body.dataset["compareClear"]) {
            this.clear(true);
        }
        else {

            // If compare cookie exists, reload data from storage
            if (window.Utils.getCookie(this.getLocalStorageKey())) {
                var data = JSON.parse(document.body.dataset["compareItems"]);
                this.items = data;
                this.fire("change");
            }
            else {
                this.fire("change");
                this.save();
            }

        }

        $(window).on("storage", (e) => {
            e = e.originalEvent;

            if (e.key === null) {
                this.clear();
                return;
            }

            // Shitty IE do not fires the event if value is too long
            if (e.key !== "UPDATE_COMPARE") {
                return;
            }

            // If shitty IE, then postpone the event
            if (
                navigator.appName == 'Microsoft Internet Explorer' ||  
                !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || 
                (typeof $.browser !== "undefined" && $.browser.msie == 1)
            ) {
                setTimeout(() => {
                    this.loadFromStorage()
                }, 300);
            }
            else {
                this.loadFromStorage();
            }
        });
    },

    /**
     * Adds listener for given event or events
     *
     * @param      {string|Array}  event     The event or array of events
     * @param      {Function}      callback  The callback
     */
    on: function(event, callback) {

        if (typeof event == "string") {
            var events = [ event ];
        }
        else {
            var events = event;
        }

        for (var i = 0; i < events.length; i++) {
            var event = events[i];

            if (typeof this.listeners[event] == "undefined") {
                this.listeners[event] = [];
            }

            this.listeners[event].push(callback);
        }
        
    },

    /**
     * Removes listener for given event
     *
     * @param      {string}    event     The event
     * @param      {Function}  callback  The callback
     */
    off: function(event, callback) {

        if (typeof this.listeners[event] == "undefined") {
            return;
        }

        if (this.listeners[event].indexOf(callback) > -1 ){
            this.listeners[event].splice(this.listeners[event].indexOf(callback), 1);
        }
    },

    /**
     * Fires an event with given data 
     *
     * @param      {string}  event   The event
     * @param      {mixed}  data    The data
     */
    fire: function(event, data) {

        if (typeof this.listeners[event] == "undefined") {
            return;
        }

        for (var i = 0, len = this.listeners[event].length; i < len; i++) {
            this.listeners[event][i].apply(this, data);
        }
    }

   
}
